import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
var n = null;

function r(n) {
  return null != n;
}

function t(n) {
  return null == n;
}

function u(n) {
  return void 0 === n;
}

function o(t, u) {
  return r(t) ? u(t) : n;
}

function e(n) {
  return n;
}

function f(n, r) {
  if (t(n)) throw new Error(r);
  return n;
}

function c(n, t) {
  return r(n) ? n : "function" == typeof t ? t() : t;
}

function l(n) {
  return r(n) && n.destroy(), null;
}

function i(n) {
  return r(n) && n.dispose(), null;
}

function s(n) {
  return r(n) && n.remove(), null;
}

function a(n) {
  return r(n) && n.abort(), null;
}

function h(n) {
  return r(n) && n.release(), null;
}

function p(n, t) {
  return r(n) && r(t) ? n.equals(t) : n === t;
}

function w(n) {
  return null;
}

function y(n, t) {
  var u = new Array();
  return n.forEach(function (n) {
    var o = t(n);
    r(o) && u.push(o);
  }), u;
}

function d(n, r) {
  var t = new Array();

  var _iterator = _createForOfIteratorHelper(n),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _u = _step.value;
      t.push(A(_u, null, r));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return t;
}

function v(n, r) {
  var _iterator2 = _createForOfIteratorHelper(n),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _t = _step2.value;
      A(_t, null, r);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}

function A(n, t, u) {
  return r(n) ? u(n) : t;
}

function E(n, t) {
  return r(n) ? t(n) : null;
}

function b(n, t) {
  var _iterator3 = _createForOfIteratorHelper(n),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _u2 = _step3.value;

      var _n = t(_u2);

      if (r(_n)) return _n;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return null;
}

function g(n) {
  return n.filter(function (n) {
    return r(n);
  });
}

function m(n) {
  var t = n;

  for (var _len = arguments.length, r = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    r[_key - 1] = arguments[_key];
  }

  for (var _u3 = 0; _u3 < r.length && t; ++_u3) {
    t = t[r[_u3]];
  }

  return t;
}

function q(n) {
  return n;
}

export { a as abortMaybe, E as andThen, o as applySome, q as assumeNonNull, l as destroyMaybe, i as disposeMaybe, p as equalsMaybe, g as filterNones, v as forEachSome, m as get, t as isNone, r as isSome, u as isUndefined, d as mapMany, A as mapOr, y as mapSome, b as mapSomeFirst, n as none, w as nullifyNonnullableForDispose, h as releaseMaybe, s as removeMaybe, e as unwrap, c as unwrapOr, f as unwrapOrThrow };